module.exports = __webpack_public_path__ + "img/alarm_clock.b6404376.gif";